import invoices from './invoices.js'
import returnInvoices from './returnInvoices.js'
import suggest from './suggest.js'

export default {
  menu: 'Purchases',
  title: 'Purchases',

  general: {
    labels: {
      id: 'Invoice ID',
      sourceInvoice: 'Source',
      user: 'Supplier',
      date: 'Registration date',
      status: 'Status',
      store: 'Store',
      fullName: 'Full Name',
      address: 'Address',
      orderDate: 'Order Date',
      phoneNumber: 'Phone number',
      pre: 'pre',
      note: 'Note',
      tax: 'Vat',
      taxPercent: 'Vat percent',
      totalDiscount: 'Total discount',
      totalPrice: 'Total price',
      finalPrice: 'Final price',
      shipping: 'Shipping',
      vatInc: 'vat Inc',
      vatExc: 'vat Exc'
    },

    placeholders: {
      id: 'Automatic'
    },

    table: {
      header: {
        id: 'Invoice number',
        creator: 'Creator',
        user: 'Supplier',
        company: 'Company',
        province: 'Province',
        date: 'Date',
        totalDiscount: 'Discount',
        totalVat: 'Vat',
        shipping: 'Shipping',
        finalPrice: 'Amount',
        status: 'Status',
        category: 'Category',
        lastModifiedDate: 'Update',
        delete: 'Delete',
        restore: 'Restore'
      }
    },

    lines: {
      table: {
        header: {
          delete: 'Delete',
          edit: 'Edit',
          storeroom: 'Store',
          finalPrice: 'Amount',
          totalPrice: 'Total',
          tax: 'Vat Amount',
          taxRate: 'Vat',
          unitPrice: 'Unit price',
          netTaxable: 'Net taxable',
          discount: 'Total discount',
          count: 'Qty',
          variant: 'Variable',
          name: 'Product',
          barcode: 'Barcode',
          row: 'Row'
        }
      }
    }
  },

  invoices,

  returnInvoices,

  suggest
}
